import React, { Fragment, useCallback } from 'react';
import { MDFContentPane, MDFModalDialog } from '../../../index';
import { Field } from './types';

/**
 * Wraps a field component with double-dare confirmation dialog functionality
 * @param rendering - The rendered field component
 * @param field - Field configuration with optional double-dare settings
 * @param onChange - Callback function for field changes
 * @returns JSX element with field and optional confirmation dialog
 */
export function renderFieldWithDoubleDare(rendering: React.ReactNode, field: Field, onChange: (field: Field) => void) {
  const onYes = useCallback(() => {
    onChange({
      ...field,
      showDoubleDare: false
    });
  }, [field, onChange]);

  const onNo = useCallback(() => {
    onChange({
      ...field,
      showDoubleDare: false,
      data: {
        ...field.data,
        ...field.doubleDare.safeData
      }
    });
  }, [field, onChange]);

  return (
    <Fragment>
      {rendering}
      {field.doubleDare && (
        <MDFModalDialog
          show={field.showDoubleDare}
          modalType={'Alert'}
          size={'md'}
          backdrop={true}
          closeable={false}
          title={field.doubleDare.title}
          yesButtonText={field.doubleDare.yesLabel}
          noButtonText={field.doubleDare.noLabel}
          onYes={onYes}
          onNo={onNo}
        >
          <MDFContentPane html={field.doubleDare.content} />
        </MDFModalDialog>
      )}
    </Fragment>
  );
}
